// ─────────────────────────────────────────────────────────────────
// Glass-i — DGU consumable ISSUE helpers (Stage DGU-CONSUMABLE-3).
//
// Pure client-side suggestion math for the manual-issue screen. The server is
// authoritative for the deduction; these only pre-fill the operator's quantities
// from the work order's geometry (perimeter × spacer-frames, net) and each
// picked item's per_unit_factor. The operator always confirms.
// ─────────────────────────────────────────────────────────────────

export function num(v) {
  if (v === null || v === undefined || v === '') return 0;
  const n = Number(v);
  return Number.isFinite(n) ? n : 0;
}
export function round3(v) {
  const n = Number(v);
  return Number.isFinite(n) ? Math.round(n * 1000) / 1000 : 0;
}

// Suggested issue qty for a consumable, from the work order geometry + the item.
//   geometry = { unitCount, spacerFrames, perimeterMeters, spacerMeters }
//   item     = { consumableKind, perUnitFactor }
// Bases (docs/78): spacer = metres directly; desiccant = kg/m of spacer;
// sealants = per metre of perimeter; corner keys = 4 × spacer frames (per_unit_factor
// overrides the 4 when set). Returns 0 when it can't be derived — the operator types it.
export function suggestQtyFor(item, geometry) {
  if (!item || !geometry) return 0;
  const kind = String(item.consumableKind || '').toLowerCase();
  const f = num(item.perUnitFactor);
  const spacerM = num(geometry.spacerMeters);
  const perimM = num(geometry.perimeterMeters);
  const frames = num(geometry.spacerFrames);
  switch (kind) {
    case 'spacer': return round3(spacerM);
    case 'desiccant': return f > 0 ? round3(spacerM * f) : 0;
    case 'primary_sealant':
    case 'secondary_sealant': return f > 0 ? round3(perimM * f) : 0;
    case 'corner_key': return round3(frames * (f > 0 ? f : 4));
    default: return 0;
  }
}

// The basis tag stored on the line (audit/display only).
export function basisFor(kind) {
  const k = String(kind || '').toLowerCase();
  if (k === 'spacer') return 'SPACER_METERS';
  if (k === 'desiccant' || k === 'primary_sealant' || k === 'secondary_sealant' || k === 'corner_key') return 'FACTOR';
  return 'MANUAL';
}

const NF3 = new Intl.NumberFormat('en-IN', { minimumFractionDigits: 0, maximumFractionDigits: 3 });
export function fmtQty(v) { const n = Number(v); return Number.isFinite(n) ? NF3.format(n) : '—'; }
